import { Component, ComponentChild } from 'preact'
import Search from '../algolia/components/Search'
import axios, { AxiosResponse } from 'axios'
import { FeaturedTopicInterface } from '../featured-topics/FeaturedTopics'
import Icon from '../assets'

export interface TopicBannerData {
  id: number
  title: string
  url: string
  contentType: string
}

interface TopicData {
  id: number
  type: string
}

interface Props {
  onChange: (state: {selectedTopic: null|TopicData}) => void
  switcher?: ComponentChild
  dragHandle?: ComponentChild
  config: {
    selectedTopic: null|TopicBannerData
  }
}

interface State {
  selectedTopic: null|TopicBannerData
}

class TopicBannerWithHelp extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      selectedTopic: props.config.selectedTopic
    }

    this.setValue = this.setValue.bind(this)
    this.onChangeSend = this.onChangeSend.bind(this)
  }

  async componentDidMount () {
    const { data }: AxiosResponse<{content: FeaturedTopicInterface[]}> = await axios.get('/homepage/featuredTopics', {
      params: {
        topicIds: [this.props.config.selectedTopic]
      }
    })

    this.setState({
      selectedTopic: data.content[0]
    })
  }

  setValue (value: null|TopicBannerData) {
    this.setState({
      selectedTopic: value
    }, () => this.onChangeSend())
  }

  onChangeSend () {
    const newData = {
      selectedTopic: this.state.selectedTopic !== null ? { id: this.state.selectedTopic.id, type: this.state.selectedTopic.contentType } : null
    }

    this.props.onChange(newData)
  }

  render (props: Props, { selectedTopic }: State) {
    return (
      <div class='content-curation-manager topic-banner_configuration'>
        <div className='widget-configuration_info-box'>
          <strong>✨ What’s a shared widget?</strong>
          <p>As a shared widget, the configurations of this widget would be used on all pages in community.</p>
        </div>
        <p><strong>Topic</strong></p>
        {
          selectedTopic === null || typeof selectedTopic === 'undefined'
            ? (
              <Search
                isControl
                searchPlaceholder='Search for topics or enter a topic URL'
                callback={foundTopic => {
                  this.setValue({
                    id: foundTopic.id,
                    title: foundTopic.title,
                    url: foundTopic.topic_url,
                    contentType: foundTopic.content_type === 'ideation' ? 'idea' : foundTopic.content_type
                  })
                }}
                submitIconType='add'
              />
              )
            : (
              <div class='topic-banner_selected-topic-info'>
                <span class='topic-banner_selected-topic-title'>{selectedTopic.title}</span>
                <span class='topic-banner_selected-topic__delete' onClick={() => this.setValue(null)}>
                  <Icon icon='trash' width={16} height={16} color='#6B707E' />
                </span>
              </div>
              )
          }
      </div>
    )
  }
}

export default TopicBannerWithHelp
